// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FeedbackIssueButton__button-ac23db {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--base-110);
  background: var(--base-20);
  border-radius: 100px;
  padding: 8px 16px;
  margin-inline-end: 4px;
  margin-bottom: 8px;
  cursor: pointer;
}

.FeedbackIssueButton__button-ac23db:hover {
  background: var(--brand-primary-40);
  color: var(--addition-50);
}

.FeedbackIssueButton__active-c95c42 {
  background: var(--brand-primary-40);
  color: var(--addition-50);
}`, "",{"version":3,"sources":["webpack://./src/main/Popups/DetailedFeedback/components/FeedbackIssueButton/FeedbackIssueButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,0BAAA;EACA,oBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,mCAAA;EACA,yBAAA;AACF;;AAEA;EACE,mCAAA;EACA,yBAAA;AACF","sourcesContent":[".button {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--base-110);\n  background: var(--base-20);\n  border-radius: 100px;\n  padding: 8px 16px;\n  margin-inline-end: 4px;\n  margin-bottom: 8px;\n  cursor: pointer;\n}\n\n.button:hover {\n  background: var(--brand-primary-40);\n  color: var(--addition-50);\n}\n\n.active {\n  background: var(--brand-primary-40);\n  color: var(--addition-50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `FeedbackIssueButton__button-ac23db`,
	"active": `FeedbackIssueButton__active-c95c42`
};
module.exports = ___CSS_LOADER_EXPORT___;
